"use client";

import React, { type ReactElement } from "react";
import { ThemeListItem } from "@/components";
import { ThemeLegend } from "@/types";

interface ThemeListProps {
  themes: ThemeLegend[];
}

function ThemeList({ themes }: Readonly<ThemeListProps>): ReactElement {
  return (
    <ul className="list-none flex flex-col gap-1">
      {themes.map((theme): ReactElement => {
        return (
          <ThemeListItem
            count={theme.count}
            key={theme.type}
            label={theme.label}
            type={theme.type}
          />
        );
      })}
    </ul>
  );
}

export { ThemeList };
